import { AbiItem } from 'web3-utils';

const abi: AbiItem[] = [
  {
    inputs: [],
    payable: false,
    stateMutability: 'nonpayable',
    type: 'constructor',
  },
  {
    constant: true,
    inputs: [],
    name: 'owner',
    outputs: [
      {
        internalType: 'address',
        name: '',
        type: 'address',
      },
    ],
    payable: false,
    stateMutability: 'view',
    type: 'function',
  },
  {
    constant: false,
    inputs: [
      {
        internalType: 'address payable[]',
        name: '_to',
        type: 'address[]',
      },
      {
        internalType: 'uint256[]',
        name: '_value',
        type: 'uint256[]',
      },
    ],
    name: 'sendEth',
    outputs: [
      {
        internalType: 'bool',
        name: '_success',
        type: 'bool',
      },
    ],
    payable: true,
    stateMutability: 'payable',
    type: 'function',
  },
  {
    constant: false,
    inputs: [
      {
        internalType: 'address',
        name: '_tokenAddress',
        type: 'address',
      },
      {
        internalType: 'address[]',
        name: '_to',
        type: 'address[]',
      },
      {
        internalType: 'uint256[]',
        name: '_value',
        type: 'uint256[]',
      },
    ],
    name: 'sendErc20',
    outputs: [
      {
        internalType: 'bool',
        name: '_success',
        type: 'bool',
      },
    ],
    payable: false,
    stateMutability: 'nonpayable',
    type: 'function',
  },
];

export const BitwaveMultiSendContract = {
  contractName: 'BitwaveMultiSend',
  abi,
  bytecode:
    '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',
};
